import { applyFloatingCornerRadius, applyScaledTypeRamp, DialogStyles, glyphSizeNumber, horizontalSpacing, horizontalSpacingNumber, neutralForegroundRest, } from "@microsoft/fast-components-styles-msft";
import { merge } from "lodash-es";
import { directionSwitch, multiply, subtract, toPx } from "@microsoft/fast-jss-utilities";
const styles = (config) => {
    return merge(DialogStyles, {
        dialog: {
            "& $dialog_closeButton": {
                "min-width": "unset",
            },
        },
        dialog__singleAction: {
            "& $dialog_primaryButton": {
                "grid-column-start": "2",
            },
        },
        dialog_contentRegion: Object.assign({ "box-sizing": "border-box", display: "flex", "flex-direction": "column", padding: toPx(multiply(horizontalSpacingNumber(), 2)), position: "relative" }, applyFloatingCornerRadius()),
        dialog_actionWrapper: {
            "box-sizing": "border-box",
            display: "grid",
            "grid-template-columns": "1fr 1fr",
            "grid-gap": "8px",
            width: "100%",
            "margin-top": "18px",
        },
        dialog_body: Object.assign(Object.assign({ flex: "1 1 0", "margin-top": "8px" }, applyScaledTypeRamp("t8")), { color: neutralForegroundRest, "text-overflow": "ellipsis", overflow: "hidden" }),
        dialog_heading: {
            display: "inline-block",
        },
        dialog_primaryButton: {
            position: "relative",
        },
        dialog_secondaryButton: {
            position: "relative",
        },
        dialog_closeButton: {
            "box-sizing": "border-box",
            position: "absolute",
            transition: "none",
            top: toPx(horizontalSpacingNumber()),
            left: directionSwitch("", horizontalSpacing()),
            right: directionSwitch(horizontalSpacing(), ""),
            "& $dialog_closeButtonGlyph": {
                width: toPx(subtract(glyphSizeNumber, 6)),
                height: toPx(subtract(glyphSizeNumber, 6)),
            },
        },
        dialog_closeButtonGlyph: {
            fill: neutralForegroundRest,
        },
    });
};
export default styles;
